import React, { useEffect, useState } from "react";
import axiosInstance, { handleApiError } from "../../services/axiosService";
import ButtonActionIcon from "./ButtonActionIcon";
import Input from "../FormComponents/Input";
import Textarea from "../FormComponents/Textarea";
import MultiSelectBox from "../FormComponents/MultiSelectBox";

const NotesAndTags = ({ notesValue, tagValue, onChange }) => {
  const handleNotesValue = (e) => {
    onChange(e.target.value, "description");
  };
  return (
    <div className="builder_form">
      {tagValue && <UniqueTag tagValue={tagValue} onChange={onChange} />}
      <Textarea label="Notes" id="contentText" value={notesValue} onChange={handleNotesValue} />
    </div>
  );
};

const UniqueTag = ({ tagValue, onChange }) => {
  const [options, setOptions] = useState([]);
  const [newTag, setNewTag] = useState("");
  const [showCreateTag, setShowCreateTag] = useState(false);

  const fetchAllTags = async () => {
    try {
      const { data } = await axiosInstance.get(`/tag`);
      setOptions(data);
    } catch (error) {
      handleApiError(error);
    }
  };
  const handleTags = (data) => {
    const idOnlyData = data.map((item) => item.id);
    onChange(idOnlyData, "info_tag");
  };
  const addNewTag = async () => {
    if (newTag.trim() === "") {
      return;
    }
    try {
      const { data } = await axiosInstance.post(`/tag`, { name: newTag });
      setOptions([...options, data]);
      onChange([...tagValue, data.id], "info_tag");
      setNewTag("");
    } catch (error) {
      handleApiError(error);
    }
  };

  //convert array of id to array of object
  const getValueData = () => {
    return options.filter((option) => tagValue.includes(option.id));
  };

  useEffect(() => {
    fetchAllTags();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="builder_form ">
      <MultiSelectBox options={options || []} selectedData={getValueData()} onChange={handleTags} label="Assign Tags" />

      <div className="d_flex gap_2 align_center">
        <Input type="checkbox" checked={showCreateTag} onChange={(e) => setShowCreateTag(e.target.checked)} />
        <label>Want to create new tag?</label>
      </div>
      {showCreateTag && (
        <>
          <div className="d_flex gap_2 align_center mb_2">
            <Input
              type="text"
              value={newTag}
              onChange={(e) => setNewTag(e.target.value)}
              placeholder="Enter new tag"
              label="Create new tag"
            />
            <ButtonActionIcon
              type="add"
              size="sm"
              onClick={addNewTag}
              style={{ marginTop: "auto", marginBottom: "4px" }}
            />
          </div>
        </>
      )}
    </div>
  );
};
export default NotesAndTags;
